<template>
  <div>
    
 <GameHistory />
    <HomeBanner />
    
    <HomeMobile />
     
      <HomeCategory
      :categories="categories"
      :selectedCategory="selectedCategory"
      @update:selectedCategory="handleCategorySelect"
    />

    <Search />
       
   <HomeGame :selectedCategory="selectedCategory || 'lobby'" />

 
   


  </div>
</template>

<script>
import HomeBanner from '@/components/home/HomeBanner.vue';
import HomeMobile from '@/components/home/HomeMobile.vue';
import HomePromo from '@/components/home/HomePromo.vue';
import HomeCategory from '@/components/home/HomeCategory.vue';
import Search from '@/components/Search.vue';
import HomeGame from '@/components/home/HomeGame.vue';
import GameHistory from '@/components/GameHistory.vue';
import Bets from '@/components/bets/Bets.vue';
import axios from 'axios';

export default {
  name: 'Home',
  components: {
    HomeBanner,
    HomePromo,
    HomeMobile,
    HomeCategory,
    Search,
    HomeGame,
    GameHistory,
    Bets
  },
  data() {
    return {
      categories: [],
      selectedCategory: 'lobby'
    };
  },
  created() {
    axios.get('/public/categories')
      .then(res => {
        this.categories = res.data || [];
      })
      .catch(err => {
        console.error('Kategori verisi alınamadı:', err);
      });
  },
    methods: {
    handleCategorySelect(slug) {
  this.selectedCategory = slug;
}

  }
};
</script>
